import ProductAuthorCreateButton from "./product-author-create-button";

export default ProductAuthorCreateButton;